<template>
  <div
    :class="{ 'text-right': sentBy === 'user' }"
    class="mb-4 mr-4 ml-4 message"
    @mouseover="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <b-row v-if="isDiscussion" @click="$emit('go-to-discussion', id)" class="cursor-pointer">
      <p>
        <strong>{{ sentBy }}</strong> has started a discussion.
      </p>
    </b-row>

    <div v-else-if="sentBy === 'user'">
      <b-row>
        <b-col class="pr-2">
          <div class="message__bubble right">
            <audio v-if="audioId" :src="url" controls></audio>
          </div>
        </b-col>

        <b-col cols="0" md="1" class="pl-0"></b-col>
      </b-row>

      <b-row>
        <b-col class="pr-2">
          <div class="message__bubble right">
            <div style="border-radius: 0px 0px 0px 15px">
              <!-- <img @click="$emit('reply', { id, sentBy, text })" src="@/assets/icons/reply.svg" class="icon icon-sm mr-1" /> -->
              <img @click="$emit('remove', { id, sentBy, text })" src="@/assets/icons/trash.svg" class="icon icon-xs" />
            </div>

            <b-img v-if="imageId" :src="url" fluid rounded width="300" />
            <div v-else class="rounded-lg text-white p-3 bg-primary" style="width: 90%" v-html="text"></div>
          </div>
        </b-col>

        <b-col cols="0" md="1" class="pl-0">
          <vue-gravatar :email="user.email" class="avatar d-block ml-auto mr-auto rounded-circle float-right" width="40" />
        </b-col>
      </b-row>
    </div>

    <b-row v-else>
      <b-col cols="0" md="1" class="pr-0">
        <img :src="pickyPictureUrl" class="bg-white avatar d-block ml-auto mr-auto rounded-circle float-left border" width="40" />
      </b-col>

      <b-col class="pl-2">
        <div class="message__bubble">
          <div class="float-right" style="border-radius: 0px 0px 0px 15px">
            <!-- <img @click="$emit('reply', { id, sentBy, text })" src="@/assets/icons/reply.svg" class="icon icon-sm ml-2" /> -->
            <img @click="$emit('remove', { id, sentBy, text })" src="@/assets/icons/trash.svg" class="icon icon-xs ml-1" />
          </div>

          <audio v-if="audioUrl" :src="audioUrl" controls></audio>
          <div class="rounded-lg p-3 text-white bg-lightblack" v-html="sanitizedText"></div>
        </div>
      </b-col>

      <b-col cols="12" md="0" class="pr-0 mt-n1">
        <img :src="pickyPictureUrl" class="bg-white avatar d-block ml-auto mr-auto rounded-circle float-left border" width="40" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BRow, BCol, BImg } from "bootstrap-vue";
import VueGravatar from "vue-gravatar";

export default {
  name: "Message",
  components: { BRow, BCol, BImg, VueGravatar },
  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },

    imageId: {
      type: String,
      default: null,
    },
    audioId: {
      type: String,
      default: null,
    },
    audioUrl: {
      type: String,
      default: null,
    },

    sentBy: {
      type: String,
      required: true,
    },

    isDiscussion: {
      type: Boolean,
      default: false,
    },

    pickyPictureUrl: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log("this", this.text);
    console.log("url", this.url);
    console.log("audioId", this.audioId);
  },
  computed: {
    ...mapState({ user: (state) => state.auth.user }),
    sanitizedText() {
      const { text } = this;
      return text.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
  },
  data: () => ({
    isHovering: false,
  }),
};
</script>

<style lang="scss" scoped>
.right {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 0;
}

.message {
  .message__bubble {
    // width: 600px;
    width: 100%;
  }
}
</style>
